/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MezziResponseDTO
 */
export interface MezziResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof MezziResponseDTO
     */
    idMezzo?: number;
    /**
     * 
     * @type {string}
     * @memberof MezziResponseDTO
     */
    descrizione?: string | null;
}

/**
 * Check if a given object implements the MezziResponseDTO interface.
 */
export function instanceOfMezziResponseDTO(value: object): value is MezziResponseDTO {
    return true;
}

export function MezziResponseDTOFromJSON(json: any): MezziResponseDTO {
    return MezziResponseDTOFromJSONTyped(json, false);
}

export function MezziResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MezziResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idMezzo': json['idMezzo'] == null ? undefined : json['idMezzo'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
    };
}

export function MezziResponseDTOToJSON(json: any): MezziResponseDTO {
    return MezziResponseDTOToJSONTyped(json, false);
}

export function MezziResponseDTOToJSONTyped(value?: MezziResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idMezzo': value['idMezzo'],
        'descrizione': value['descrizione'],
    };
}

